import React from "react";
import './Footer.css';
import FooterLogo from '../../Assets/footerlogo.png';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useNavigate } from "react-router-dom";


function Footer(){
    const navigate = useNavigate();
    return(
        <>
            <div className="footer-container">
                <div className="footer-container-inner">
                    <div className="footer-logo">
                        <img src={FooterLogo} alt='logo'/>
                    </div>
                    <div>
                        <h2>company</h2>
                        <ul>
                            <li onClick={()=>navigate('/')}>home</li>
                            <li onClick={()=>navigate('/services')}>services</li>
                            <li onClick={()=>navigate('/ourscience')}>our Science</li>
                        </ul>
                    </div>
                    <div>
                        <h2 onClick={()=>navigate('/aboutus')}>about us</h2>
                        <ul>
                            <li onClick={()=>navigate('/aboutus')}>team</li>
                            <li onClick={()=>navigate('/aboutus')}>mission</li>
                            <li onClick={()=>navigate('/aboutus')}>values</li>
                        </ul>
                    </div>
                    <div>
                        <h2 onClick={()=>navigate('/contactus')}>support</h2>
                        <ul>
                            <li onClick={()=>navigate('/contactus')}>contact us</li>
                            <li onClick={()=>navigate('/career')}>career</li>
                            <li onClick={()=>navigate('/services')}>FAQ's</li>
                        </ul>
                    </div>
                    <div>
                        <h2 onClick={()=>navigate('/contactus')}>Contact us</h2>
                        <ul>
                            <li>+91 9535876050</li>
                            <li>Lankarao@ardeslabs.com</li>
                            <li>Plot No 103/B, Road No 9,ALEAP IndustrialArea,  Gajularamaram, Hyderabad-500090, Telangana. </li>
                        </ul>
                    </div>
                </div>
                <div className="footer-four-icons">
                    <div>
                        <TwitterIcon sx={{fontSize:18}}/>
                    </div>
                    <div>
                        <LinkedInIcon sx={{fontSize:18}}/>
                    </div>
                    <div>
                        <InstagramIcon sx={{fontSize:18}}/>
                    </div>
                    <div>
                        <FacebookIcon sx={{fontSize:18}}/>
                    </div>
                </div>

                {/* footer circles */}
                <div className="footer-circle1"></div>
                <div className="footer-circle2"></div>
                <div className="footer-circle3"></div>
                <div className="footer-circle4"></div>
                <div className="footer-circle5"></div>
                <div className="footer-circle6"></div>
            </div>
        </>
    );
}

export default Footer;